import React, { useEffect, useState } from "react";
import { Button, Checkbox, message, Modal, Select } from "antd";
import {
  getShareChatLink,
  setCancelSubscriptionAPI,
  setChatFeedbackAPI,
  setDeleteChatHistoryAPI,
  setLogoutUserAPI,
  setUserDeleteAccountAPI,
} from "../../redux/actions/ChatWithData/ChatWithDataApi";
import { useDispatch, useSelector } from "react-redux";
import {
  setChatWithDataResponse,
  setCreditLimitExhausted,
  setOtpStatusFlag,
  setSelectedChatData,
  setShareChatID,
  setSignUpFailedFlag,
} from "../../redux/actions/ChatWithData/ChatWithData";
import { useNavigate } from "react-router-dom";
import creditLimitExhaustedImg from "../../assets/credit_limit_exhausted_img.svg";
import CloseIconBlack from "../../assets/ChatWithData/close_black_icon.svg";
import ContentCopyIcon from "../../assets/ChatWithData/content_copy_icon.svg";
import CopyIconWhite from "../../assets/ChatWithData/copy_icon_white.svg";
import XIconWhite from "../../assets/ChatWithData/x_icon_white.svg";
import WhatsappIconWhite from "../../assets/ChatWithData/whatsapp_icon_white.svg";
import MailIconWhite from "../../assets/ChatWithData/mail_icon_white.svg";
import GreenTickedCircle from "../../assets/ChatWithData/green_ticked_circle.svg";
import TextArea from "antd/lib/input/TextArea";
import "./Custom.css";
import { trackEvent } from "../utils/posthog";

const { Option } = Select;

const CustomModal = ({
  isModalOpen,
  setShowCustomModal,
  title,
  sub_title,
  option,
  session_id,
  temp_session_id,
  setShowOptionPopUp,
  setShowThreeDotIcon,
  setIsShowChatHistorySidebar,
  setIsShowSidebar,
  setShowNavbar,
  showNavbar,
  el,
  setNegativeFeedbackEnabled,
  setOtherIssueEnabled,
  setShowFeedback,
  showWholeSession,
  setShowWholeSession,
  showShareModal,
  setShowShareModal,
  showRestoreModal,
  setShowRestoreModal,
  query_id,
  onKeepEditing,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const chatTopicsHistory = useSelector(
    (state) => state?.ChatWithData?.chat_topics_history
  );
  const userProfileDetails = useSelector(
    (state) => state?.ChatWithData?.user_profile_details
  );
  const deleteAccountReasonList = useSelector(
    (state) => state?.ChatWithData?.delete_account_reason_list
  );
  const negativeFeedbackReasonList = useSelector(
    (state) => state?.ChatWithData?.negative_feedback_reason_list
  );
  const chatWithDataRes = useSelector(
    (state) => state?.ChatWithData?.chat_with_data_res
  );
  const shareableLink = useSelector(
    (state) => state?.ChatWithData?.shareableLink
  );
  let p_token = localStorage.getItem("p_token");
  let visitor_id = localStorage.getItem("visitor_id");

  const [deleteAccountReason, setDeleteAccountReason] = useState("");
  const [deleteAccountComment, setDeleteAccountComment] = useState("");
  const [negativeReview, setNegativeReview] = useState("Others");
  const [negativeCustomReview, setNegativeCustomReview] = useState("");
  const [linkCopied, setLinkCopied] = useState(false);

  const handleLandingPage = () => {
    // Redirect to landing page
    navigate("/");

    dispatch(
      setSignUpFailedFlag({
        flag: false,
        message: null,
      })
    );
  };

  const handleOk = () => {
    let payloadObj = {};
    if (option === "delete") {
      trackEvent("FR_CHAT_DELETION_CONFIRMED", {
        session_id: session_id || temp_session_id,
        delete_type: "single_chat",
        is_temp_session: !session_id && !!temp_session_id,
      });
      payloadObj = {
        p_token: p_token,
        session_id: session_id,
        temp_session_id: temp_session_id,
        clear_all: false,
        chat_list_api_obj: {
          offset: 0,
          session_id: null,
          p_token: p_token ? p_token : null,
        },
        chatTopicsHistory: chatTopicsHistory,
        total_length: chatTopicsHistory?.total_length,
      };
      dispatch(setDeleteChatHistoryAPI(payloadObj));
    } else if (option === "delete_all") {
      trackEvent("FR_CHAT_DELETION_CONFIRMED", {
        delete_type: "all_history",
      });
      payloadObj = {
        p_token: p_token,
        session_id: session_id,
        clear_all: true,
        chat_list_api_obj: {
          offset: 0,
          session_id: null,
          p_token: p_token ? p_token : null,
        },
      };
      dispatch(setDeleteChatHistoryAPI(payloadObj));
    } else if (option === "log_out") {
      handleLogoutUserFunction();
    } else if (option === "cancel_subscription") {
      trackEvent("FR_SUBSCRIPTION_CANCELLATION_CONFIRMED", {
        subscription_id:
          userProfileDetails?.payment_info?.subscription_id || null,
      });
      let obj = {
        p_token: p_token ? p_token : null,
        subscription_id: userProfileDetails?.payment_info?.subscription_id
          ? userProfileDetails?.payment_info?.subscription_id
          : null,
        cancel_at_cycle_end: 1,
      };
      dispatch(setCancelSubscriptionAPI(obj));
    } else if (option === "delete_account") {
      trackEvent("FR_ACCOUNT_DELETION_CONFIRMED", {
        reason: deleteAccountReason,
        comment: deleteAccountComment,
      });
      let obj = {
        p_token: p_token ? p_token : null,
        exit_review: deleteAccountReason ? deleteAccountReason : "",
        is_custom_review: deleteAccountComment ? deleteAccountComment : "",
      };
      dispatch(setUserDeleteAccountAPI(obj));
    } else if (option === "negative_feedback") {
      trackEvent("FR_RESPONSE_FEEDBACK_GIVEN", {
        session_id: el?.session_id,
        query_id: el?.query_id,
        feedback_type: "negative",
        reason: negativeReview,
        custom_review_text: negativeCustomReview,
        visitor_id: visitor_id || null,
      });
      let payloadObj = {
        session_id: el?.session_id,
        query_id: el?.query_id,
        feedback_flag: 1,
        chatWithDataRes: chatWithDataRes,
        p_token: p_token ? p_token : null,
        visitor_id: visitor_id ? visitor_id : null,
        exit_review: negativeReview ? negativeReview : null,
        is_custom_review: negativeCustomReview ? negativeCustomReview : null,
      };
      dispatch(setChatFeedbackAPI(payloadObj));
      // Close All Pop Up
      setNegativeFeedbackEnabled(false);
      setOtherIssueEnabled(false);
      setShowFeedback(false);
    } else if (option === "discard_changes" || option === "discard_changes_and_navigate") {
      // Handled by ProfilePage — just close the modal
    } else if (option === "restore") {
      trackEvent("FR_SESSION_RESTORE_CONFIRMED", {
        visitor_id,
      });
      setShowRestoreModal(false);
      localStorage.removeItem("returning_user");
    } else if (option === "sign_up_failed") {
      // Redirect to landing page
      navigate("/");

      dispatch(
        setSignUpFailedFlag({
          flag: false,
          message: null,
        })
      );
      return;
    }

    setShowCustomModal({
      flag: false,
      title: null,
      sub_title: null,
      option: null,
    });

    if (
      option !== "log_out" &&
      option !== "cancel_subscription" &&
      option !== "delete_account" &&
      option !== "credit_limit_exhausted" &&
      option !== "negative_feedback" &&
      option !== "sign_up_failed" &&
      option !== "discard_changes" &&
      option !== "discard_changes_and_navigate"
    ) {
      // Close Option Pop Up
      setShowOptionPopUp({
        index: null,
        text: null,
        flag: false,
      });
      setShowThreeDotIcon({
        index: null,
        text: null,
        flag: false,
      });
    }
  };

  const handleLogoutUserFunction = () => {
    // Close Chat History Sidebar (if prop is provided)
    if (setIsShowChatHistorySidebar) {
      setIsShowChatHistorySidebar(false);
    }

    // Close Trending Question Sidebar (if prop is provided)
    if (setIsShowSidebar) {
      setIsShowSidebar(false);
    }

    // Logout API Call
    let payloadObj = {
      p_token: p_token,
    };
    dispatch(setLogoutUserAPI(payloadObj));

    const keyToKeep = "visitor_uuid";
    const valueToKeep = localStorage.getItem(keyToKeep); // Store the value

    // clear local stoarge
    localStorage.clear();

    if (valueToKeep !== null) {
      localStorage.setItem(keyToKeep, valueToKeep); // Restore the key
    }

    // Redirect to landing page
    navigate("/");
    dispatch(setOtpStatusFlag(false));

    // Reset Chat Response
    let obj = {
      persist_data: [],
      data: [],
      total_length: null,
    };
    dispatch(setChatWithDataResponse(obj));

    // Reset selected chat data
    dispatch(setSelectedChatData(null));

    // Close Mobile sidebar
    if (showNavbar) {
      setShowNavbar(false);
    }
  };

  const handleCancel = () => {
    if (option === "sign_up_failed") {
      // Redirect to landing page
      navigate("/");

      dispatch(
        setSignUpFailedFlag({
          flag: false,
          message: null,
        })
      );
      return;
    }

    if (option === "mobile_number_required") {
      // Redirect to profile page
      navigate("/profile");
      setShowCustomModal({
        flag: false,
        title: null,
        sub_title: null,
        option: null,
      });
      return;
    }

    if (option === "share" || option === "visitor-flow") {
      return;
    }
    if (option === "restore") {
      setShowRestoreModal(false);
      localStorage.removeItem("returning_user");
      return;
    }

    // For discard modals, use onKeepEditing callback if provided
    if ((option === "discard_changes" || option === "discard_changes_and_navigate") && onKeepEditing) {
      onKeepEditing();
      return;
    }

    setShowCustomModal({
      flag: false,
      title: null,
      sub_title: null,
      option: null,
    });

    if (
      option !== "log_out" &&
      option !== "cancel_subscription" &&
      option !== "delete_account" &&
      option !== "credit_limit_exhausted" &&
      option !== "negative_feedback" &&
      option !== "share_chat" &&
      option !== "share_artifact" &&
      option !== "sign_up_failed" &&
      option !== "discard_changes" &&
      option !== "discard_changes_and_navigate"
    ) {
      // Close Option Pop Up
      setShowOptionPopUp({
        index: null,
        text: null,
        flag: false,
      });
      setShowThreeDotIcon({
        index: null,
        text: null,
        flag: false,
      });
    }

    // Close Flag
    dispatch(setCreditLimitExhausted(false));
  };

  const handleSignUp = () => {
    if (!p_token && query_id) {
      navigate(`/sign-up/query/${query_id}`);
      setShowCustomModal({
        flag: false,
        title: null,
        sub_title: null,
        option: null,
      });
    } else {
      dispatch(setCreditLimitExhausted(false));
      navigate("/sign-up");
      setShowCustomModal({
        flag: false,
        title: null,
        sub_title: null,
        option: null,
      });
    }
  };

  const handleUpgradePlan = () => {
    trackEvent("FR_UPGRADE_PLAN_CLICKED", {});
    dispatch(setCreditLimitExhausted(false));
    navigate("/pricing");
    setShowCustomModal({
      flag: false,
      title: null,
      sub_title: null,
      option: null,
    });
  };

  const handleChangeDeleteAccountReason = (value) => {
    setDeleteAccountReason(value);
  };

  const handleSelectBadResponse = (review) => {
    setNegativeReview(review);
  };

  // handle create link,copy

  const handleClick = (el, type) => {
    if (shareableLink?.link) {
      copyText();
    } else {
      let obj = {
        p_token: p_token ? p_token : null,
      };
      if (option === "share_artifact") {
        obj.session_id = el?.session_id;
        // obj.artifact_id = el?.artifact_id;
        obj.query_id = el?.query_id;
      } else {
        obj.query_id = !showWholeSession ? el?.query_id : null;
        obj.session_id = el?.session_id;
      }
      dispatch(getShareChatLink(obj, option));
    }
  };

  const copyLink = () => {
    if (shareableLink?.link) {
      copyText();
    }
  };

  // copy share link
  const copyText = () => {
    setLinkCopied(true);

    // message.success({
    //   content: "Copied",
    //   className: "custom-ant-message",
    // });

    // Get the HTML content from the element
    const htmlContent = document.getElementById("copy-sharelink");

    const plainText = htmlContent?.getAttribute("value") || "";

    // Create a temporary textarea to copy the text from
    const tempTextArea = document.createElement("textarea");
    tempTextArea.value = plainText;
    document.body.appendChild(tempTextArea);

    // Select and copy the text
    tempTextArea.select();
    document.execCommand("copy");

    // Remove the temporary textarea
    document.body.removeChild(tempTextArea);

    // alert("Text copied to clipboard!");
    // callNotification("Text Copied", "Success");

    // let payloadObj = {
    //   authParams: authParams,
    //   session_id: el?.session_id,
    //   query_id: el?.query_id,
    //   feedback_flag: 2, // Copy Text Flag
    //   chatWithDataRes: chatWithDataRes,
    //   p_token: p_token ? p_token : null,
    //   visitor_id: visitor_id ? visitor_id : null,
    // };
    // dispatch(setChatFeedbackAPI(payloadObj));
  };
  useEffect(() => {
    if (shareableLink?.link) {
      copyText();
    }
  }, [shareableLink?.link]);
  useEffect(() => {
    setLinkCopied(false);
    dispatch(
      setShareChatID({
        id: null,
        link: null,
      })
    );
  }, [showWholeSession]);
  useEffect(() => {
    let time;
    if (linkCopied) {
      time = setTimeout(() => {
        setLinkCopied(false);
      }, 5000);
    }
    return () => {
      clearTimeout(time);
    };
  }, [linkCopied]);
  const handleCheckbox = (e) => {
    setShowWholeSession(e.target.checked);
  };

  const handleRestoreModal = () => {
    setShowRestoreModal(false);
    localStorage.removeItem("returning_user");
  };

  return (
    <>
      <Modal
        centered
        className={`custom_modal_container ${
          option === "share_chat" || option === "share_artifact"
            ? "share_chat_modal"
            : option === "share"
            ? "shared-message-modal"
            : option === "negative_feedback"
            ? "negative_feedback_modal"
            : option === "mobile_number_required"
            ? "mobile_number_modal"
            : ""
        }`}
        open={isModalOpen || showShareModal || showRestoreModal}
        onOk={handleOk}
        onCancel={handleCancel}
        closable={
          option === "negative_feedback"
            ? true
            : option === "mobile_number_required"
            ? false
            : false
        }
        maskClosable={option === "mobile_number_required" ? false : true}
        footer={[
          option === "sign_up_failed" ? (
            ""
          ) : option === "negative_feedback" ? (
            <div style={{ textAlign: "right" }}>
              <Button
                key="submit"
                type="primary"
                onClick={handleOk}
                className="logout_chat_btn"
                disabled={
                  negativeReview === "Others" && negativeCustomReview
                    ? false
                    : negativeReview !== "Others" && !negativeCustomReview
                    ? false
                    : true
                }
              >
                Submit
              </Button>
            </div>
          ) : option === "delete_account" ? (
            <div style={{ textAlign: "center" }}>
              <Button
                key="submit"
                type="primary"
                onClick={handleOk}
                className="ac_delete_chat_btn"
                disabled={deleteAccountReason ? false : true}
              >
                Delete Account
              </Button>
              <Button
                key="back"
                onClick={handleCancel}
                className="logout_chat_btn"
              >
                Cancel
              </Button>
            </div>
          ) : option === "credit_limit_exhausted" ||
            option === "visitor-flow" ? (
            ""
          ) : option === "cancel_subscription" ? (
            <div style={{ textAlign: "center" }}>
              <Button
                key="submit"
                onClick={handleOk}
                className="cancel_subscription_btn"
              >
                Cancel Subscription
              </Button>
              <Button
                // type="primary"
                key="back"
                onClick={handleCancel}
                className="logout_chat_btn"
              >
                Not Now
              </Button>
            </div>
          ) : option === "share" ? (
            <div>
              <Button
                key="submit"
                onClick={() => setShowShareModal(false)}
                className="share_chat_btn"
              >
                OK
              </Button>
            </div>
          ) : option === "restore" ? (
            <div className="d-flex justify-content-center">
              <Button
                key="submit"
                onClick={() => handleRestoreModal(false)}
                className="restore_modal_btn"
              >
                OK
              </Button>
            </div>
          ) : option === "mobile_number_required" ? (
            <div className="d-flex align-items-start justify-content-center">
              <Button
                key="submit"
                onClick={handleCancel}
                className="restore_modal_btn"
                style={{ fontSize: "14px" }}
              >
                Go to Profile
              </Button>
            </div>
          ) : option === "share_chat" || option === "share_artifact" ? (
            ""
          ) : (
            <div style={{ textAlign: "center" }}>
              <Button
                key="back"
                onClick={handleCancel}
                className="cancel_delete_chat_btn"
              >
                {option === "log_out" ||
                option === "cancel_subscription" ||
                option === "delete_account"
                  ? "No"
                  : option === "discard_changes" || option === "discard_changes_and_navigate"
                  ? "Keep editing"
                  : "Cancel"}
              </Button>
              <Button
                key="submit"
                type="primary"
                onClick={handleOk}
                className={`${
                  option === "log_out" || option === "discard_changes" || option === "discard_changes_and_navigate"
                    ? "logout_chat_btn"
                    : "delete_chat_btn"
                }`}
              >
                {option === "log_out" ||
                option === "cancel_subscription" ||
                option === "delete_account"
                  ? "Yes"
                  : option === "discard_changes" || option === "discard_changes_and_navigate"
                  ? "Discard"
                  : "Delete"}
              </Button>
            </div>
          ),
        ]}
        width={
          option === "sign_up_failed"
            ? "500px"
            : option === "negative_feedback"
            ? "50%"
            : "400px"
        }
        styles={{ header: { borderBottom: "none" } }}
      >
        {option === "sign_up_failed" ? (
          <>
            {/* <p className="delete_chat_pop_up_sub_title">{title}</p> */}
            <div className="sign_up_failed_container">
              <div className="sign_up_failed_card">
                <div className="sign_up_failed_icon">⏳</div>
                <h2 className="sign_up_failed_title">You're on the Waitlist!</h2>
                <p className="sign_up_failed_description">
                  Thanks for your interest in CMOverse.ai. We're preparing for
                  our next batch induction.
                </p>
                <div className="sign_up_failed_message-box">
                  We'll send you an email with the next steps. Keep an eye on
                  your inbox!
                </div>
                <div className="sign_up_failed_update-info">
                  <span className="sign_up_failed_email-icon">📧</span> Stay tuned
                  for updates.
                </div>
                <button
                  className="sign_up_failed_button"
                  onClick={handleLandingPage}
                >
                  Back to Homepage
                </button>
              </div>
            </div>
          </>
        ) : option === "negative_feedback" ? (
          <>
            <p className="custom_negative_feedback_container_title">
              Provide additional feedback
            </p>
            <div className="negative_feedback_box_pill_container">
              {negativeFeedbackReasonList?.map((d) => {
                return (
                  <span
                    onClick={() => handleSelectBadResponse(d)}
                    className={`${
                      d === negativeReview
                        ? "selected_negative_feedback_box_pill"
                        : "negative_feedback_box_pill"
                    } `}
                  >
                    {d}
                  </span>
                );
              })}
            </div>
            <TextArea
              style={{
                background: "#202c3e",
                border: "1px solid #2e3f59",
                borderRadius: "12px",
                color: "#fff",
                marginTop: "20px",
              }}
              className="delete_chat_pop_up_input_area"
              rows={4}
              placeholder="Feel free to add specific details"
              value={negativeCustomReview}
              onChange={(e) => setNegativeCustomReview(e?.target?.value)}
              maxLength={200}
            />
          </>
        ) : option === "delete_account" ? (
          <>
            <p className="ac_delete_chat_pop_up_title">Delete Account?</p>
            <p className="ac_delete_chat_pop_up_sub_title">
              <span style={{ color: "yellow" }}>⚠︎ </span>Warning❗ All your
              data, including profile information, settings, and history will be
              permanently removed.
            </p>

            <p className="ac_delete_chat_pop_up_para">
              Please tell us why you're leaving?
            </p>
            <Select
              dropdownStyle={{ backgroundColor: "#202c3e" }}
              className="delete-account-reason-select"
              placeholder="Select the reason"
              onChange={(value) => handleChangeDeleteAccountReason(value)}
              value={
                deleteAccountReason ? deleteAccountReason : "Select the reason"
              }
            >
              {deleteAccountReasonList.map((el, i) => {
                return (
                  <Select.Option
                    key={i}
                    value={el}
                    style={{ color: "lightgrey" }}
                  >
                    {el}
                  </Select.Option>
                );
              })}
            </Select>

            <p className="ac_delete_chat_pop_up_para">
              Additional comment (optional)
            </p>
            <TextArea
              style={{
                background: "#202c3e",
                border: "1px solid #2e3f59",
                borderRadius: "12px",
                color: "#fff",
              }}
              className="delete_chat_pop_up_input_area"
              rows={3}
              placeholder="Type your comment here..."
              value={deleteAccountComment}
              onChange={(e) => setDeleteAccountComment(e?.target?.value)}
              maxLength={100}
            />
          </>
        ) : option === "share_chat" || option === "share_artifact" ? (
          <>
            <div className="d-flex flex-direction-column gap-20">
              <div
                className="d-flex"
                style={{ justifyContent: "space-between" }}
              >
                <div style={{ fontSize: "18px" }}>{title}</div>
                <img
                  src={CloseIconBlack}
                  alt="close icon"
                  className="cursor-pointer"
                  onClick={handleCancel}
                />
              </div>
              <div className="share_subtitle">{sub_title}</div>
              {option !== "share_artifact" ? (
                <div className="share_subtitle d-flex align-items-center gap-10">
                  <p className="p-0 m-0">Share whole session</p>
                  <Checkbox
                    className=""
                    onChange={(e) => handleCheckbox(e)}
                    value="enable-whole-session"
                    checked={showWholeSession ? true : false}
                  />
                </div>
              ) : (
                ""
              )}
              <div className="copy_link_container">
                <p
                  id="copy-sharelink"
                  value={shareableLink?.link || ""}
                  className={`${!shareableLink?.link ? "dummy-link" : ""}`}
                  onClick={() => copyLink()}
                >
                  {shareableLink?.link
                    ? shareableLink?.link?.length > 40
                      ? shareableLink?.link?.slice(0, 40) + "..."
                      : shareableLink?.link
                    : "https://cmoverse.ai/share/..."}
                </p>
                <div
                  className={`d-flex gap-10 align-items-center copy-link ${
                    linkCopied ? "link-copied" : ""
                  }`}
                  onClick={() => handleClick(el, option)} // copyText
                >
                  {linkCopied || shareableLink?.link ? (
                    <img
                      src={
                        linkCopied
                          ? GreenTickedCircle
                          : shareableLink?.link
                          ? CopyIconWhite
                          : ""
                      }
                      alt="copy icon"
                    />
                  ) : (
                    ""
                  )}
                  <p>
                    {!shareableLink?.link
                      ? "Create link"
                      : linkCopied
                      ? "Copied"
                      : "Copy"}
                  </p>
                </div>
              </div>
              {/* Commented for now, but this is in design */}
              {/* <div className="share-icon-container">
                <p>or share chat to</p>
                <div className="share-channel-icons">
                  <img src={MailIconWhite} alt="email icon" />
                  <span className="show-pipe"></span>
                  <img src={WhatsappIconWhite} alt="whatsapp icon" />
                  <span className="show-pipe"></span>
                  <img src={XIconWhite} alt="x icon" />
                </div>
              </div> */}
            </div>
            {/* <p className="delete_chat_pop_up_title">{title}</p>
            <p className="delete_chat_pop_up_sub_title"></p> */}
          </>
        ) : option === "share" ? (
          <>
            <div className="d-flex flex-direction-column gap-20">
              <div
                className="d-flex"
                style={{ justifyContent: "space-between" }}
              >
                <div style={{ fontSize: "18px" }}>
                  This is shared chat. Click OK to continue.
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <p className="delete_chat_pop_up_title">{title}</p>
            {option === "credit_limit_exhausted" ? (
              <img
                className="credit_limit_exhausted_img"
                src={creditLimitExhaustedImg}
              />
            ) : (
              ""
            )}
            {/* <p className="delete_chat_pop_up_sub_title">{sub_title}</p> */}
            {option === "mobile_number_required" ? (
              <div style={{ textAlign: "center", marginTop:"25px"}}>
                <span className="delete_chat_pop_up_sub_title">
                  A mobile number is required to continue.
                </span>
                <br />
                <span className="delete_chat_pop_up_sub_title">
                  Please update your profile to proceed.
                </span>
              </div>
            ) : (
              <p className="delete_chat_pop_up_sub_title">{sub_title}</p>
            )}

            {option === "credit_limit_exhausted" ? (
              <Button
                onClick={p_token ? handleUpgradePlan : handleSignUp}
                className="custom_modald_dynamic_btn"
              >
                {p_token ? "Upgrade plan" : "Sign up"}
              </Button>
            ) : option === "visitor-flow" ? (
              <Button
                onClick={handleSignUp}
                className="custom_modald_dynamic_btn"
              >
                {"Sign up"}
              </Button>
            ) : (
              ""
            )}
          </>
        )}
      </Modal>
    </>
  );
};
export default CustomModal;
